<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="站点：">
            <el-cascader
              class="search-ascader"
              v-model="form.siteIdList"
                :options="siteOptions"
                :props="props"
                 placeholder="请选择"
                 filterable
                 collapse-tags
                clearable></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="社区：">
            <el-select v-model="form.communityId" filterable placeholder="请选择" @change="communityIdChange">
                <el-option
                  v-for="item in communityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点：">
            <el-select v-model="form.siteId" filterable placeholder="请选择">
                <el-option
                  v-for="item in siteOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item> -->
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('积分统计')">导出</el-button>
        </el-form>
      </div>
    </div>
    <div class="chart-tile-section">
      <div class="chart-tile-item" v-for="(item, index) in tileData" :key="index">
        <div class="label">{{item.label}}</div>
        <div class="value">{{item.value}}</div>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-item chart-item-long">
        <div class="chart-item-canvas-full" id="sasPointsTotalChart"></div>
      </div>
      <div class="chart-item">
        <div class="chart-item-canvas-full" id="sasPointsPayChart"></div>
      </div>
      <div class="chart-item">
        <div class="chart-item-canvas-full" id="sasPointsConsumeChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  name: 'StatisticalAnalysisPoints',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        communityId: '',
        orgId1: '',
        orgId2: '',
        orgId3: '',
        siteId: '',
        siteIdList: []
      },
      communityOptions: [],
      siteOptions: [],
      props: { children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', multiple: true, emitPath: false },
      chartEle: {
        totalChart: null,
        consumeChart: null,
        payChart: null
      },
      tileData: [
        { label: '积分累计发放总量：', value: 0 },
        { label: '积分消耗量：', value: 0 },
        { label: '积分余量池：', value: 0 }
      ]
    }
  },
  created() {
    this.initCreated()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    initCreated() {
      this.orgTreeList()
    },
    // 初始化页面
    initPage() {
      this.siteStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          communityId: '',
          siteId: '',
          siteIdList: []
        }
        // this.communityIdChange()
      }
      this.initPage()
    },
    communityIdChange() {
      this.form.siteId = ''
      if (this.form.communityId) {
        this.$store.dispatch('querySiteListNoPageList', this.form.communityId).then(res => {
          this.siteOptions = res
        })
      } else {
        this.siteOptions = []
      }
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = '站点' + (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/statisticalSite/siteStatisticalImport',
        data: this.getReqParams(), // this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 积分统计
    siteStatistical() {
      this.$api.statistical.points.siteStatistical(this.getReqParams()).then(res => {
        this.$nextTick(() => {
          this.initTotalChart(this.transResData(res.data.statisticalSiteResult, 2))
          this.initConsumeChart(res.data.statisticalConsumptionResults)
          this.initPayChart(res.data.statisticalIssueResults)
          this.tileData[0].value = res.data.sumIssueCount
          this.tileData[1].value = res.data.sumConsumptionCount
          this.tileData[2].value = res.data.sumRemainingCount
        })
      })
    },
    getReqParams() {
      return {
        dataTimeRange: this.form.dataTimeRange,
        communityId: '',
        siteIdList: this.form.siteIdList,
        orgId1: '', // this.form.siteId.length === 1 ? this.form.siteId.slice(-1)[0] : '',
        orgId2: '', // this.form.siteId.length === 2 ? this.form.siteId.slice(-1)[0] : '',
        orgId3: ''// this.form.siteId.length === 3 ? this.form.siteId.slice(-1)[0] : '',
        // siteId: this.form.siteId.length === 4 ? this.form.siteId.slice(-1)[0] : ''
      }
    },
    // 总体
    initTotalChart(data) {
      this.chartEle.totalChart = this.$echarts.init(document.getElementById('sasPointsTotalChart'))
      this.chartEle.totalChart.setOption(this.createOption({
        title: { text: '积分总体情况表', left: 'center' },
        color: ['#5baf33', '#3373ca'],
        legend: { left: 'center', bottom: 'bottom', data: ['积分总量', '积分消耗量'] },
        grid: { right: 0, left: '5%' },
        xNames: data.xNames,
        series: [
          {
            name: '积分总量',
            type: 'bar',
            data: data.y1Names
          },
          {
            name: '积分消耗量',
            type: 'bar',
            data: data.y2Names
          }
        ]
      }))
    },
    // 消耗
    initConsumeChart(data) {
      this.chartEle.consumeChart = this.$echarts.init(document.getElementById('sasPointsConsumeChart'), 'light')
      const seriesData = []
      const exchangeType = {
        1: '商品兑换',
        2: '物业费',
        3: '扣除',
        4: '赠送积分'
      }
      for (const item of data) {
        seriesData.push({
          value: item.count,
          name: exchangeType[item.typeName]
        })
      }
      const option = {
        title: { text: '积分消耗', left: 'center' },
        tooltip: { trigger: 'item' },
        legend: { left: 'center', bottom: 'bottom' },
        // color: ['#fe7503', '#429dda'],
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            data: seriesData,
            label: {
              show: false,
              position: 'center'
            }
          }
        ]
      }
      this.chartEle.consumeChart.setOption(option)
    },
    // 发放
    initPayChart(data) {
      this.chartEle.payChart = this.$echarts.init(document.getElementById('sasPointsPayChart'), 'light')
      const seriesData = []
      for (const item of data) {
        seriesData.push({
          value: item.count,
          name: item.name
        })
      }
      const option = {
        title: { text: '积分发放', left: 'center' },
        tooltip: { trigger: 'item' },
        legend: { left: 'center', bottom: 'bottom' },
        // color: ['#ffcb00', '#5baf33', '#3373ca', '#1b457c', '#a07100'],
        series: [
          {
            name: '',
            type: 'pie',
            radius: '70%',
            data: seriesData,
            label: {
              show: false,
              position: 'center'
            }
          }
        ]
      }
      this.chartEle.payChart.setOption(option)
    },
    // 重绘
    resizeView() {
      for (const key in this.chartEle) {
        if (this.chartEle[key]) {
          this.chartEle[key].resize()
        }
      }
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.siteOptions = res.data
      })
    }
  }
}
</script>
